var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('img',{staticClass:"not-img",attrs:{"src":require("@/assets/imgs/404.png"),"alt":""}}),_vm._v(" "),_c('div',[_vm._v("页面走丢了...")]),_vm._v(" "),_c('div',{staticClass:"back",on:{"click":_vm.toHome}},[_vm._v("返回首页")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da90096","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/404.vue
// module id = null
// module chunks = 